{
    "worker": false,
    "results": {
        "x;x;1979-11-01T00:00:00+01:00": {
            "policyNumber": "6700720106"
           
        }
    }
}